<template>
    <div class="shadow-sm p-3 rounded my-4 w-100 table">

        <h3><strong>Historico de pagos</strong></h3>

        <!-- Historico -->
        <b-table
            responsive
            striped
            hover
            :items="monthlyPayments.data"
            :fields="columns"
            empty-text="No hay resultados para mostrar."
            show-empty
            thead-tr-class="table-active"
        >
            <template v-slot:cell(actions)="data">
                <div class="d-flex justify-content-around align-items-center">
                    <ToggleCheckComponent
                        :id="`status-monthly-payment-item-list-id-${data.item.id}`"
                        :model="data.item.is_active"
                        :onChange="() => onChangeStatusMonthlyPayment(data.item.id)"
                    />

                    <el-tooltip content="Editar pago" placement="top" effect="dark" size="small">
                        <i class="fa fa-edit fa-lg text-info mx-1" @click="onHandleShowToEditPayment(data.item)" />
                    </el-tooltip>
                </div>
            </template>
        </b-table>

        <!-- Paginación -->
        <div class="mb-4">
            <el-pagination
                v-if="monthlyPayments.data && !!monthlyPayments.data.length"
                v-model="filter.page"
                @size-change="changeQuantityResultsPagination"
                @current-change="changePageInPagination"
                :current-page.sync="filter.page"
                class="float-right"
                :page-size.sync="filter.per_page"
                :page-sizes="[10, 30, 50, 100, 500, 1000]"
                layout="total, sizes, prev, pager, next"
                :total="monthlyPayments.total"
            />
            <br />
        </div>

    </div>
</template>

<script>

// Generales
import { mapState, mapActions, mapMutations } from 'vuex';
import moment from 'moment';

// Componentes
import ToggleCheckComponent from '../../../../shared/components/Toggle-check.vue'

export default {
    name: 'montjly-payments-history',
    components: { ToggleCheckComponent },
    data() {
        return {
            columns: [
                {
                    key: 'date_start',
                    label: 'Fecha inicio',
                    sortable: true,
                    formatter: (value, key, item) => {
                        return this.formatDate(value).format('L')
                    },
                },
                {
                    key: 'date_end',
                    label: 'Fecha fin',
                    sortable: true,
                    formatter: (value, key, item) => {
                        return this.formatDate(value).format('L')
                    },
                },
                {
                    key:
                    'quantity_hours',
                    label: 'Horas',
                    sortable: true
                },
                {
                    key:
                    'description',
                    label: 'Detalles',
                    sortable: true
                },
                {
                    key:
                    'actions',
                    label: 'Opciones'
                },
            ],
        }
    },
    computed: {
        // Pagos mensuales de las licencias.
        ...mapState('monthlyPayments', [
            'monthlyPayments',
            'filter'
        ]),
        // Empresa activa.
        ...mapState('empresa', [ 'selectedEmpresa' ]),
         // Licencias.
        ...mapState('licencias', [ 'licencia' ])
    },
    methods: {
        // Pagos mensuales de las licencias
        ...mapActions('monthlyPayments', [
            'getAllByCompany',
            'chageStatusMonthlyPayment'
        ]),
        ...mapMutations('monthlyPayments', [
            'setMonthlyPayment',
            'setIsShowFormMonthlyPayment',
            'setFilterDataMonthlyPayments'
        ]),
        // Configuracióon para usar Moment
        formatDate: function (date) {
            return moment(date);
        },
        /**
         * Cambiar el estado de un pago.
         *
         * @author Fernando Claros
         */
        async onChangeStatusMonthlyPayment(paymentId) {
            const payload = {
                id: paymentId,
                idCompany: this.selectedEmpresa.id
            }
            await this.chageStatusMonthlyPayment(payload);
        },
        /**
         * Mostrar datos del pago para editarlo.
         *
         * @author Fernando Claros
         */
        onHandleShowToEditPayment(payment) {
            this.setMonthlyPayment({
                ...payment,
                dates: [payment.date_start, payment.date_end],
                action: 'UPDATE'
            });
            this.setIsShowFormMonthlyPayment(true);
        },
        /**
         * Cambiar de pagina en el paginador.
         *
         * @author Fernando Claros
         */
        changePageInPagination(page) {
            const nextFilter = { ...this.filter, page };

            this.setFilterDataMonthlyPayments(nextFilter);
            this.processLoad(nextFilter);
        },
        changeQuantityResultsPagination(per_page) {
            const nextFilter = { ...this.filter, page: 1, per_page };

            this.setFilterDataMonthlyPayments(nextFilter);
            this.processLoad(nextFilter);
        },
        processLoad(nextFilter) {
            const payload = {
                idLicense: this.licencia.id,
                idCompany: this.selectedEmpresa.id,
                page: nextFilter.page,
                sortBy: nextFilter.sortBy,
                sort: nextFilter.sort,
                per_page: nextFilter.per_page,
            };
            this.getAllByCompany(payload)
        }
    }
};
</script>

<style scoped>
table thead tr th {
    padding: 6px;
    background-color: white;
}
table tbody tr td {
    border-bottom: 1px solid #ccc;
}
label {
    margin-bottom: 0 !important;
}
.table{
    width: 100%;
    min-width: 400px;
    overflow: auto;
}
</style>
